
//import ExamReportConfig from "@/views/configs/medical_report_template/index.vue";

import ExamReportConfig from "@/views/configs/exam_report/index.vue";

export default [
  {
    path: "relatorios-exames",
    name: "Relatório de Exames",
    component: ExamReportConfig,
  },
];
